export const yoyChange = (change) => {
	return change === Number('-999999') ? 'NA' : `${change}% YoY`;
};

export const gridChange = (change) => {
	if (change === undefined) {
		return 0;
	}
	return change === Number('-999999') ? 'NA' : change;
};

export const chartTitleChange = (change) => {
	if (change !== 0 && !change) {
		return '';
	}
	return change === '999,999' ? 'NA' : `${change}%`;
};
